// reducer.js
import * as types from "../actionTypes";

const initialState = {
  data: [],
  isLoading: false,
  message: "",
  status:false
};

const industryTypeReducer = (state = initialState, action) => {
  console.log(action.payload);
  switch (action.type) {
    case types.FETCH_INDUSTRY_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.FETCH_INDUSTRY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        status:action.payload.status
      };
    case types.FETCH_INDUSTRY_FAILURE:
      return {
        ...state,
        isLoading: false,
        data: [],
        message: action.payload.message,
        status: action.payload.status,
      };
    default:
      return state;
  }
};

export default industryTypeReducer;
